import Chart from "react-apexcharts";
import moment from "moment";

const EquityChart = ({ data, showOption = true }) => {
  const series = [
    {
      name: "Equity",
      data: data.downsampled_timestamps.map((timestamp, index) => ({
        x: moment(timestamp).format("YYYY-MM-DD HH:mm"),
        y: data.downsampled_adv_equity[index]?.toFixed(2),
      })),
      color: "#0C4CFC",
    },
  ];

  const options = {
    chart: {
      type: "line",
      height: 350,
      zoom: { enabled: true },
    },
    stroke: {
      width: 1,
    },
    xaxis: {
      type: "datetime",
      labels: {
        formatter: (value) => moment(value).format("DD MMM , HH:mm"),
      },
    },
    grid: {
      show: true,
      borderColor: "#e0e0e0",
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    yaxis: {
      title: {
        text: "Equity Value",
      },
    },
    tooltip: {
      x: {
        formatter: (value) => moment(value).format("DD MMM YYYY, HH:mm"),
      },
    },
  };

  return (
    <Chart
      options={options}
      series={series}
      type="line"
      height={400}
      width="100%"
    />
  );
};

export default EquityChart;
